import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/close.svg` */
export const CloseIcon = createTripletGlyphIcon('CloseIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.089 2.78748C12.3428 2.53382 12.7541 2.53397 13.008 2.78748C13.2618 3.04132 13.2618 3.45356 13.008 3.7074L8.80096 7.91346L13.1808 12.2933C13.4345 12.5471 13.4344 12.9584 13.1808 13.2123C12.927 13.4661 12.5148 13.4661 12.2609 13.2123L7.88201 8.83338L3.73846 12.9769C3.4846 13.2306 3.0723 13.2307 2.81854 12.9769C2.56507 12.7231 2.56599 12.3117 2.81951 12.058L6.96209 7.91346L2.99139 3.94275C2.73778 3.68889 2.73763 3.2766 2.99139 3.02283C3.24517 2.76937 3.65657 2.7703 3.91033 3.02381L7.88104 6.99451L12.089 2.78748Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.6661 3.14901C13.9395 2.87576 14.383 2.87581 14.6564 3.14901C14.9297 3.42236 14.9296 3.86589 14.6564 4.13925L9.85754 8.93807L14.8068 13.8873C15.0798 14.1606 15.0798 14.6042 14.8068 14.8775C14.5335 15.1508 14.0899 15.1507 13.8165 14.8775L8.86731 9.92831L4.18372 14.6119C3.91037 14.8852 3.46685 14.8852 3.19348 14.6119C2.92025 14.3385 2.92016 13.895 3.19348 13.6217L7.87708 8.93807L3.34387 4.40487C3.07051 4.1315 3.07051 3.688 3.34387 3.41464C3.61726 3.14149 4.06081 3.14134 4.33411 3.41464L8.86731 7.94784L13.6661 3.14901Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.2928 4.22282C18.6442 3.87156 19.2138 3.87166 19.5653 4.22282C19.9165 4.57423 19.9174 5.14384 19.5662 5.49528L13.0955 11.965L19.7186 18.5871C20.0699 18.9385 20.0698 19.509 19.7186 19.8605C19.3671 20.2117 18.7965 20.2118 18.4451 19.8605L11.8221 13.2375L5.55451 19.506C5.20308 19.8573 4.63348 19.8573 4.28205 19.506C3.93092 19.1546 3.93085 18.585 4.28205 18.2336L10.5496 11.965L4.4344 5.8488C4.08329 5.49729 4.08402 4.92769 4.43537 4.57633C4.78676 4.22544 5.35551 4.22538 5.70686 4.57633L11.8231 10.6916L18.2928 4.22282Z"
        fill="currentColor"
      />
    </svg>
  ),
});
